// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Y-Gv","inner":"Footer_inner__m9grC","nextIcon":"Footer_nextIcon__3FykD","innerLeft":"Footer_innerLeft__2kEBM"};